initMarquee('.Index_information_marquee', {
    mobile: {
        duration: 55000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 55000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});